module.exports = __webpack_public_path__ + "static/media/2022-gz.56f0aa69.jpg";